module.exports = __webpack_public_path__ + "img/circle-cut.11c1fc34.svg";